/** 공용 숫자 포맷 — 로케일은 전 화면 en-US 고정. */
export const fmt = (n: number) => n.toLocaleString("en-US");
export const fmtRound = (n: number) => Math.round(n).toLocaleString("en-US");
